import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { SendMoneyDetail } from '../../models/sendmoney/sendmoney';
import { AboutUsComponent } from '../../sharedcomponents/about-us/about-us.component';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { SharepromotainalPopupComponent } from '../../sharedcomponents/sharepromotionalcode/sharepromotainal-popup/sharepromotainal-popup.component';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.css'],
  providers: []
})
export class PaymentReceiptComponent implements OnInit {
  sendMoneyDetail: SendMoneyDetail;
  appSettings: any;
  branchImageData: any;
  customerCareNumber;
  constructor(
    private router: Router,
    public sendMoneyService: SendMoneyService,
    public utilityServ: utilityService,
    public modal: Modal,
    public translate: TranslateService,
    public geoloc: geolocation
  ) {
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });

    const branchDetail: any = {};
    branchDetail.PayingAgentId = this.utilityServ.getObjectText(this.sendMoneyDetail.agentDetails.PayingAgentId);
    branchDetail.LocationId = this.utilityServ.getObjectText(this.sendMoneyDetail.agentDetails.LocationId);

    this.utilityServ.busy = this.sendMoneyService.getBranchImage(branchDetail).subscribe(data => {
      if (data.HasDefaultImage == true) {
        this.branchImageData = '';
      } else {
        this.branchImageData = 'data:image/gif;base64,' + data.BranchImageData;
      }
    }, error => {});
  }

  ngOnInit() {
    const CountryObject = this.geoloc.getCountryObject();
    this.customerCareNumber = this.utilityServ.getCustomerCarePhone(CountryObject);
  }

  opentermsofuse(objtext) {
    let modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblTermsConditions');
    modalData.URL = objtext;
    modalData.Action = this.translate.instant('Common_lblOk');
    return this.modal.open(AboutUsComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {});
    });
  }
  openShareModal() {
    let modalData: any = {};
    return this.modal.open(SharepromotainalPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {});
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/payment-receipt/payment-receipt.component.ts